<template>
  <v-sheet>
    <v-dialog v-model="showVLDialog" persistent scrollable width="800">
      <v-card style="border-radius: 16px">
        <v-card-title
          class="d-flex align-center px-4 justify-space-between"
          style="border-bottom: 1px solid #0000001f;"
        >
          <div>
            <v-icon style="color: #363636" class="mr-1"
              >mdi-plus-box-outline</v-icon
            >
            <span style="font-size: 20px; color: #424242;">{{
              "Video From Library"
            }}</span>
          </div>

          <v-btn
            icon
            color="#424242"
            style="border-radius: 8px !important;border: 1px solid rgba(66, 66, 66, 0.05);"
            v-if="cancelCategoryList"
            @click="
              $emit('close'),
                (selectedTopicName = null),
                (videoSelected = []),
                (videos = [])
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="closeVLDialog()"
            color="#424242"
            style="
              border-radius: 8px !important;
              border: 1px solid rgba(66, 66, 66, 0.05);
            "
            v-if="showVdoList"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text style="height: 800px">
          <v-row class="mt-2">
            <v-col md="6" lg="6" xl="6" sm="12" class="pb-1">
              <v-text-field
                outlined
                dense
                hide-details
                style="border-radius: 8px; border-color: #c0c0c0"
                clearable
                prepend-inner-icon="mdi-magnify"
                placeholder="search..."
                v-model="search"
                class="mb-3"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <span class="pb-2" style="color: #363636; font-size: 20px">{{
                !showVdoList ? "Category" : selectedTopicName
              }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-1">
              <!-- Topic List -->
              <v-data-table
                v-if="!showVdoList"
                :loading="loading"
                hide-default-header
                :items="LibraryTopicList"
                :search="search"
                hide-default-footer
                class="topic-table"
                item-key="id"
                :headers="topicHeaders"
                disable-pagination
                @click:row="onRowClick"
              >
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.orgImage="{ item }">
                  <v-img :src="item.orgImage" class="lessonImg"></v-img>
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.topicName="{ item }">
                  <p>{{ item.topicName }}</p>
                </template>
              </v-data-table>
              <!-- Video list -->
              <v-data-table
                v-if="showVdoList"
                :loading="loading"
                loading-text="Loading... Please wait"
                hide-default-header
                :items="videos"
                :search="search"
                hide-default-footer
                v-model="videoSelected"
                item-key="id"
                show-select
                class="vdo-table"
                :headers="videoHeaders"
                disable-pagination
              >
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.picturebackground="{ item }">
                  <v-img
                    :src="item.picturebackground"
                    class="lessonImg"
                  ></v-img>
                </template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.lessonName="{ item }">
                  <p class="mb-2" style="font-size: 20px; color: #424242">
                    {{ item.lessonName }}
                  </p>
                  <p
                    v-if="item.partfileList && item.partfileList.length > 0"
                    style="font-size: 16px; color: #424242"
                  >
                    {{
                      item.partfileList.length === 1
                        ? item.partfileList.length + " file"
                        : item.partfileList.length + " files"
                    }}
                  </p>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions
          class="py-3 px-4"
          style="border-top: 1px solid #0000001f;"
        >
          <v-row no-gutters>
            <v-col style="text-align: right">
              <v-btn
                v-if="cancelCategoryList"
                class="text-capitalize"
                style="
                  font-size: 16px;
                  color: #424242;
                  border: 1px solid #c0c0c0;
                  border-radius: 8px;
                "
                width="100"
                text
                @click="
                  (showVLDialog = false),
                    (selectedTopicName = null),
                    (videoSelected = []),
                    (videos = [])
                "
                >{{ $t("cancel") }}</v-btn
              >
              <v-btn
                v-if="showVdoList"
                class="text-capitalize"
                style="
                  font-size: 16px;
                  color: #424242;
                  border: 1px solid #c0c0c0;
                  border-radius: 8px;
                "
                width="100"
                text
                @click="closeVLDialog()"
                >{{ $t("cancel") }}</v-btn
              >
              <v-btn
                v-if="showVdoList"
                class="text-capitalize btn_hover_effect ml-2"
                width="100"
                style="
                  font-size: 16px;
                  background: #a6cc39 0% 0% no-repeat padding-box;
                  border-radius: 8px;
                  color: #ffffff;
                "
                @click="addSelectedVideos()"
                >{{ $t("update") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import axios from "axios";
import EnUrl from "@/api/environment";
import { mapGetters } from "vuex";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      LibraryTopicList: [],
      apiUrl: EnUrl.apiUrl,
      cancelCategoryList: true,
      savedVideoList: false,
      previousVideos: [],
      selectedTopicName: null,
      showVdoList: false,
      videos: [],
      videoSelected: [],
      search: null,
      loading: false
      //selectedItem: [],
    };
  },
  computed: {
    ...mapGetters([
      "courseVideoList", // get manual add vdos or already selected vdos from the table (vdoList table data..)
      "VideoFromTopicList" // used for checking not to save duplicate video from same topic data
    ]),
    showVLDialog: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("close");
      }
    },
    topicHeaders() {
      return [
        {
          text: "",
          align: "start",
          value: "orgImage"
        },
        {
          text: this.$t("description"),
          align: "left",
          value: "topicName"
        }
      ];
    },
    videoHeaders() {
      return [
        {
          text: "",
          align: "left",
          value: "picturebackground"
        },
        {
          text: this.$t("description"),
          align: "unset",
          value: "lessonName"
        }
      ];
    }
  },
  mounted() {
    this.getLibraryTopics();
  },
  methods: {
    async getLibraryTopics() {
      let self = this;
      let ComId = "00000000-0000-0000-0000-000000000000";
      self.loading = true;
      await axios
        .get(`${self.apiUrl}Topic/GetTopics?id=` + ComId)
        .then(function(res) {
          self.loading = false;
          self.LibraryTopicList = res.data.data;
        })
        .catch(function(err) {
          self.loading = false;
          alert(err);
        });
    },
    async onRowClick(item) {
      let self = this;
      self.showVdoList = true;
      self.savedVideoList = false;
      self.cancelCategoryList = false;
      self.loading = true;
      let ComId = "00000000-0000-0000-0000-000000000000";
      await axios
        .post(`${self.apiUrl}GuidedLesson/GetGuidedContentTopicIDCustomerWeb`, {
          id: item.id,
          companyId: ComId
        })
        .then(function(response) {
          if (response.data.status === 0) {
            self.videos = response.data.data;
            self.selectedTopicName = item.topicName;
            self.loading = false;
          }
        })
        .catch(function(err) {
          throw err;
        });
    },

    closeVLDialog() {
      this.selectedTopicName = null;
      this.videoSelected = [];
      this.videos = [];
      if (this.savedVideoList) {
        this.showVLDialog = false;
        //this.$emit("close");
      } else {
        this.showVdoList = false;
        this.cancelCategoryList = true;
      }
    },
    addSelectedVideos() {
      this.showVdoList = false;

      let extractedVdoInfo = [];

      for (let item of this.videoSelected) {
        //.......
        if (item.partfileList) {
          //..........
          for (let vdo of item.partfileList) {
            //................
            let result = this.courseVideoList.find(
              x => x.oldVideoID === vdo.id
            );

            if (result == undefined) {
              extractedVdoInfo.push({
                id: 0,
                assignmentCourseID: 0,
                oldID: 0,
                oldVideoID: vdo.id,
                startContentDate: vdo.createDate,
                endContentDate: vdo.updateDate,
                videoName: vdo.songName,
                title: item.lessonName,
                description: item.wordDescription,
                size: vdo.size,
                popupTime: 0,
                duration: this.Duration(vdo.time),
                videoFile: vdo.videoFile,
                allowDownload: item.allowDownload,
                pictureBackground: item.picturebackground,
                thumbnail: item.thumbnail,
                permissionData: [],
                no: 0,
                pictureFile: ""
              });
            }
          }
        }
      }

      if (this.VideoFromTopicList?.length === 0) {
        this.$store.commit("addInCourseVideoList", extractedVdoInfo);
        this.$store.commit("saveVideoFromTopicList", extractedVdoInfo);
      } else {
        //checking already selected data.....
        //and make not to re-select already selected data.....

        let temp_Select = [];
        let temp_main = this.VideoFromTopicList;
        for (let e of extractedVdoInfo) {
          let found = this.VideoFromTopicList.find(v => v.oldVideoID !== e.id)
            ? this.VideoFromTopicList.find(v => v.oldVideoID !== e.id)
            : null;
          if (found) {
            //if already add data is not included push it..
            temp_Select.push(e);
          }
        }

        extractedVdoInfo = temp_Select;
        temp_main.push(temp_Select);
        this.$store.commit("addInCourseVideoList", extractedVdoInfo);
        this.$store.commit("saveVideoFromTopicList", temp_main);
      }
      this.savedVideoList = true;
      this.closeVLDialog();
    },

    Duration(duration) {
      let time = [
        Math.floor(duration / 60) + "",
        Math.floor(duration % 60) + ""
      ];
      time.forEach(value => {
        while (value.length < 2) value = "0" + value;
      });
      return `${time[0]}:${time[1]}`;
    }
  }
};
</script>

<style scoped>
.lessonImg {
  width: 192px !important;
  height: 100px !important;
  border-radius: 12px;
}
.topic-table.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 16px 10px !important;
}
::v-deep .v-dialog {
  border-radius: 16px;
  overflow-y: hidden !important;
}
::v-deep .v-application .primary--text {
  color: #a6cc39 !important;
  caret-color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
::v-deep .primary--text {
  color: #a6cc39 !important;
  caret-color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
::v-deep
  .topic-table.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #e9f7c6;
  cursor: pointer;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 12px 10px;
}
::v-deep
  .vdo-table.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: none;
}
::v-deep .v-simple-checkbox .mdi-checkbox-blank-outline {
  color: #c0c0c0 !important;
}
::v-deep .v-simple-checkbox .mdi-checkbox-marked {
  color: #a6cc39 !important;
}
::v-deep .v-simple-checkbox .mdi-minus-box {
  color: #a6cc39 !important;
}
::v-deep .topic-table .text-start {
  width: 212px !important;
}
::v-deep .vdo-table .text-left {
  width: 212px !important;
}
::v-deep .vdo-table .text-start {
  width: 50px !important;
}
::v-deep .primary {
  background-color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
</style>
